import React, { Component } from 'react';
import { Card, Input } from 'antd';
import OTextField from 'components/commons/OTextField';
import { translate } from 'react-i18next';

class SourcesOfInformationForm extends Component {


    constructor(props) {
        super(props);
        this.state = { persona: props.persona };
    }

    render() {
        const {t} = this.props;
        return (
        <Input.Group>
        <OTextField container={this.state.persona} fieldName="sources.books" label={t('assumption.personal.sourceInformation.books')}/>
        <OTextField container={this.state.persona} fieldName="sources.magazines" label={t('assumption.personal.sourceInformation.magazines')}/>
        <OTextField container={this.state.persona} fieldName="sources.blogs" label={t('assumption.personal.sourceInformation.blogs')}/>
        <OTextField container={this.state.persona} fieldName="sources.gurus" label={t('assumption.personal.sourceInformation.gurus')}/>
        <OTextField container={this.state.persona} fieldName="sources.other" label={t('assumption.personal.sourceInformation.others')}/>
        </Input.Group>
        );
    }

    changeField(fieldName, event) {
        this.state.persona[fieldName] = event.target.value;
        this.setState({ persona: this.state.persona });
    }
}

export default translate('translations')(SourcesOfInformationForm);


// WEBPACK FOOTER //
// ./src/components/assumptions/profiles/SourcesOfInformationForm.js